import { useEffect, useState } from "react";

export const NEW_TAB_HINT = "Ha az oldal a szerkesztő előnézeti ablakában van megnyitva, nyisd meg külön böngészőlapon.";

export const AuthLoading = () => {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setSlow(true), 8000);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-6 text-center" data-testid="auth-loading">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-white/10 border-t-[#FF3B6C]" />
      <p className="text-muted-foreground">Bejelentkezés betöltése…</p>
      {slow && <AuthHint />}
    </div>
  );
};

export const AuthHint = () => (
  <div className="max-w-md space-y-3 text-sm text-muted-foreground" data-testid="auth-hint">
    <p>{NEW_TAB_HINT}</p>
    <a href={window.location.href} target="_blank" rel="noreferrer" data-testid="auth-open-new-tab"
      className="inline-block rounded-full bg-[#FF3B6C] px-5 py-2 font-bold text-white transition-transform hover:scale-105">
      Megnyitás új lapon
    </a>
  </div>
);

export const AuthFailed = () => (
  <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-6 text-center" data-testid="auth-failed">
    <p className="font-display text-2xl font-bold">Nem sikerült betölteni a bejelentkezést</p>
    <AuthHint />
  </div>
);
